var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQualityOk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.42,
    height: 20,
    viewBox: "0 0 17.42 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1212",
    "data-name": "Groupe 1212",
    transform: "translate(-3.29 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2365",
    "data-name": "Trac\\xE9 2365",
    d: "M14.35,2H9.65A1.886,1.886,0,0,0,7.76,3.88v.94A1.878,1.878,0,0,0,9.64,6.7h4.71a1.878,1.878,0,0,0,1.88-1.88V3.88A1.871,1.871,0,0,0,14.35,2Z",
    fill: "#0f5ee9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2366",
    "data-name": "Trac\\xE9 2366",
    d: "M17.24,4.82a2.9,2.9,0,0,1-2.89,2.89H9.65A2.9,2.9,0,0,1,6.76,4.82a.747.747,0,0,0-1.1-.65A4.472,4.472,0,0,0,3.29,8.12v9.41A4.481,4.481,0,0,0,7.76,22h8.48a4.481,4.481,0,0,0,4.47-4.47V8.12a4.472,4.472,0,0,0-2.37-3.95A.747.747,0,0,0,17.24,4.82ZM12.38,16.95H8a.75.75,0,0,1,0-1.5h4.38a.75.75,0,0,1,0,1.5Zm2.62-4H8a.75.75,0,0,1,0-1.5h7a.75.75,0,0,1,0,1.5Z",
    fill: "#0f5ee9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityOk);
export default __webpack_public_path__ + "static/media/quality_ok.3c85f1e3.svg";
export { ForwardRef as ReactComponent };